import React from "react";
import { Button, ButtonGroup, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";

import classNames from "classnames";

import { useIndexContext } from "../contexts/Index";

const ClubhouseFilters = (): React.JSX.Element => {
    const { filters, setFilters } = useIndexContext();

    return (
        <Row className="ClubhouseFilters" data-testid="ClubhouseFilters">
            <Col xs={6} className="py-2 py-sm-0">
                <Form.Group controlId="search">
                    <Form.Label className={classNames("h5")}>
                        Search:
                    </Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter search value..."
                        onChange={e => {
                            setFilters(prev => ({
                                ...prev,
                                search:
                                    e.target.value.trim() === ""
                                        ? undefined
                                        : e.target.value.trim(),
                            }));
                        }}
                    />
                </Form.Group>
            </Col>
            <Col xs={6} lg={2} className="py-2 py-sm-0">
                <Form.Group controlId="ageLevel" data-testid="ageLevelFilter">
                    <Form.Label className={classNames("h5")} id="ageLevel">
                        Age Level:
                    </Form.Label>
                    <Select
                        aria-labelledby="ageLevel"
                        isSearchable={false}
                        isClearable={true}
                        isMulti={true}
                        options={filters.ageLevels.options.map((a, idx) => {
                            return {
                                value: idx,
                                label: a,
                            };
                        })}
                        onChange={a => {
                            setFilters(prev => ({
                                ...prev,
                                ageLevels: {
                                    ...prev.ageLevels,
                                    filter:
                                        a.length === 0
                                            ? undefined
                                            : a?.map(o => o.label),
                                },
                            }));
                        }}
                    />
                </Form.Group>
            </Col>
            <Col xs={6} lg={2} className="py-2 py-sm-0">
                <Form.Group
                    controlId="leagueName"
                    data-testid="leagueNameFilter"
                >
                    <Form.Label className={classNames("h5")} id="leagueName">
                        League Name:
                    </Form.Label>
                    <Select
                        aria-labelledby="leagueName"
                        isSearchable={false}
                        isClearable={true}
                        isMulti={true}
                        options={filters.leagues.options.map((a, idx) => {
                            return {
                                value: idx,
                                label: a,
                            };
                        })}
                        onChange={l => {
                            setFilters(prev => ({
                                ...prev,
                                leagues: {
                                    ...prev.leagues,
                                    filter:
                                        l.length === 0
                                            ? undefined
                                            : l?.map(o => o.label),
                                },
                            }));
                        }}
                    />
                </Form.Group>
            </Col>
            <Col xs={6} lg={2} className="py-2 py-sm-0">
                <Form.Group data-testid="leagueFilter">
                    <Form.Label className={classNames("h5")} id="league">
                        League:
                    </Form.Label>
                    <ButtonGroup>
                        <Button
                            variant={
                                filters.activeLeague === "Youth"
                                    ? "primary"
                                    : "outline-primary"
                            }
                            onClick={() =>
                                setFilters(prev => ({
                                    ...prev,
                                    activeLeague: "Youth",
                                }))
                            }
                        >
                            Youth
                        </Button>
                        <Button
                            variant={
                                filters.activeLeague === "High School"
                                    ? "primary"
                                    : "outline-primary"
                            }
                            onClick={() =>
                                setFilters(prev => ({
                                    ...prev,
                                    activeLeague: "High School",
                                }))
                            }
                        >
                            High School
                        </Button>
                    </ButtonGroup>
                </Form.Group>
            </Col>
        </Row>
    );
};

export default ClubhouseFilters;
